import axios from "axios";

const WELLSUITE = '../../WsWebServiceWellSuite/'
const PLATFORM = '../../WsWebServicePlatform/'
const HRA = '../../WsWebServiceHra/'


const requestPassword = (groupguid, username,emailtype) => {
    return axios
        .post(PLATFORM + "Participant/Pwr/" + groupguid + "/" + username + "/-1/" )
        .then((response) => {
            if(response.data.Success) {
            }
            return response.data;
        })
}

export default {
    requestPassword
}